import { useTheme } from "../store/use-theme";
import logoDark from "../assests/rensure_logo_dark.png";
import logoLight from "../assests/rensure_logo_light.png";

type Props = { className?: string; alt?: string };

// Switches logo asset for light vs dark UI
export default function BrandedLogo({
  className = "",
  alt = "Rensure",
}: Props) {
  const theme = useTheme((s) => s.theme);
  return (
    <img
      src={theme === "dark" ? logoDark : logoLight}
      alt={alt}
      className={className}
    />
  );
}
